{
  "salon-search-container": {
    "text": {
      "find-salon": "Najděte svůj salon",
      "find-salon-hint": "Vyberte prosím požadované město salonu"
    }
  }
}
